// import hooks
import { useQuery } from 'react-query';

// import queries & mutations
import { getDutyLinesAudit } from 'RestAPIs/employees/hours-table';

// import types
import { useGetDutyLinesAuditProps } from './useGetDutyLinesAudit.types';

const useGetDutyLinesAudit = (
  { employeeId, requestId }: useGetDutyLinesAuditProps,
  options: Record<string, any> = {}
) => {
  const enabled = !!requestId && (options as any).enabled !== false;

  return useQuery(
    ['dutyHistoryAudit', employeeId, requestId],
    async () => {
      if (requestId === undefined) return null;
      const { data } = await getDutyLinesAudit({
        // requestId is now number
        employeeId,
        requestId
      });
      return data;
    },
    { ...options, enabled }
  );
};

export default useGetDutyLinesAudit;
